import axios from 'axios';
import { centerCrop, makeAspectCrop } from 'react-image-crop';

export const centerAspectCrop = (
  mediaWidth: number,
  mediaHeight: number,
  aspect: number,
  width: number,
) => {
  return centerCrop(
    makeAspectCrop(
      {
        unit: 'px',
        width,
      },
      aspect,
      mediaWidth,
      mediaHeight,
    ),
    mediaWidth,
    mediaHeight,
  );
};

export const errorMessage = (error: unknown): string => {
  if (axios.isAxiosError<{ message?: string }>(error)) {
    const message = error.response?.data?.message;
    if (typeof message === 'string') {
      return message;
    }
  }
  return 'Something went wrong!';
};
